import { useQuery } from '@tanstack/react-query';
import { userServiceApi } from '../../../services/api';

export interface UserReport {
  report_id: number;
  reporter_user_id: number;
  target_type: 'user' | 'message' | 'comment';
  target_id: number;
  reason: string;
  status: 'pending' | 'resolved' | 'reviewed' | 'ignored';
  created_at: string;
}

export const useMyReports = () => {
  return useQuery<{ items: UserReport[] }, Error>({
    queryKey: ['my-reports'],
    queryFn: async () => {
      const res = await userServiceApi.get<UserReport[]>('/reports/my-reports');
      // Backend returns an array [] when empty.
      if (!res.success) throw new Error(res.error || 'failed to load');
      const items = Array.isArray(res.data) ? res.data : [];
      return { items };
    },
    staleTime: 60_000,
  });
};
